<template>
  <div>
    <div class="mt-16 flex flex-row items-center">
      <div class="grow">
        <Price
          v-if="product && selectedOffer"
          :mobile-plan="selectedMobilePlan"
          :price
          :product
          :selectedOffer
        />
      </div>

      <RevButton
        v-if="selectedOffer"
        data-id="product-page-buy-button-mobile"
        data-qa="product-page-buy-button-mobile"
        variant="primary"
        @click="onAddToCart"
      >
        {{ i18n(translations.addToCart) }}
      </RevButton>
    </div>
    <!-- @FIXME: Extract -->
    <TelcoCalculatorAdvertisement
      v-if="(isUS || isGB) && selectedOffer?.price"
      :price="selectedOffer.price"
    >
      <template #icons>
        <USTelcoCalculatorAdvertisementIcons v-if="isUS" />
        <GBTelcoCalculatorAdvertisementIcons v-if="isGB" />
      </template>
    </TelcoCalculatorAdvertisement>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Price as PriceType } from '@backmarket/http-api'
import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'
import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import type { Rating } from '@backmarket/http-api/src/api-specs-reviews/types/rating'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevButton } from '@ds/components/Button'

import { useAddToCart } from '~/scopes/product-core/components/containers/ContainerAddToCart/composables/useAddToCart/useAddToCart'
import Price from '~/scopes/product-core/components/presentationals/Price/Price.vue'
import TelcoCalculatorAdvertisement from '~/scopes/product-core/components/presentationals/TelcoCalculatorAdvertisement/TelcoCalculatorAdvertisement.vue'
import GBTelcoCalculatorAdvertisementIcons from '~/scopes/product-core/pages/ProductDetailPage/gb/components/GBTelcoCalculatorAdvertisementIcons/GBTelcoCalculatorAdvertisementIcons.vue'
import USTelcoCalculatorAdvertisementIcons from '~/scopes/product-core/pages/ProductDetailPage/us/components/USTelcoCalculatorAdvertisementIcons/USTelcoCalculatorAdvertisementIcons.vue'

import { useProductTracking } from '../../composables/useProductTracking'

import translations from './TitleDesktop.translations'

const props = withDefaults(
  defineProps<{
    selectedOffer?: GetPickersResponse['selectedOffer'] | null
    product: GetProductResponse
    price: PriceType
    rating?: Rating | null
    tracking: ReturnType<typeof useProductTracking>
    selectedMobilePlan?: MobilePlanOffer
  }>(),
  {
    selectedOffer: null,
    rating: null,
    selectedMobilePlan: undefined,
  },
)

const { addToCart } = useAddToCart()
const i18n = useI18n()
const marketplace = useMarketplace()

const isUS = computed(() => {
  return marketplace.market.countryCode === MarketCountryCode.US
})
const isGB = computed(() => {
  return marketplace.market.countryCode === MarketCountryCode.GB
})

function onAddToCart() {
  if (props.selectedOffer) {
    addToCart({
      listingId: props.selectedOffer.offerLegacyId,
      listingPublicId: props.selectedOffer.offerId,
      tracking: {
        ...props.tracking.product.value,
        list: 'product_page',
        campaign_id: props.selectedOffer.campaignId,
        population_id: props.selectedOffer.populationId,
      },
      partnerPromoCodes: props.product.includedServiceOffers.partnerPromoCodes,
      isTradeInEligible: props.product.isTradeInEligible,
      promoCodes: props.product.promoCodes,
    })
  }
}
</script>
